<mat-form-field class="w-100 dense-2" [appearance]="appearance">
  <mat-label>{{ label() | translate }}</mat-label>
  <input
    matInput
    inputmode="numeric"
    maxlength="10"
    placeholder="DD/MM/AAAA"
    (input)="onDateInput($event)"
    [matDatepickerFilter]="dateFilter"
    [matDatepicker]="picker"
    [formControl]="formControlRef()"
    [required]="required()"
    [min]="minMoment()"
    [max]="maxMoment()"
  />
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker
    #picker
    [startView]="viewMode()"
    (monthSelected)="viewMode() === 'year' && onMonthSelected($event, picker)"
  ></mat-datepicker>
</mat-form-field>
